import { ChangeEvent } from 'react';
import { Ui } from '@silvertours/front-shared';

export type TimePickerType = 'from' | 'to';

type TimePickerProps = {
  type: TimePickerType;
  id: string;
  label: string;
  value?: string;
  onChange?: (time: string, type: TimePickerType) => void;
  invalid?: boolean;
  // Clarity unmask (LPOT-1716): opt-in per caller, since TimePicker is also
  // used by WidgetSearchForm, which must stay masked.
  unmaskForClarity?: boolean;
} & Pick<Ui.DropdownProps, 'onClick'>;

type Option = {
  label: string;
  value: string;
};

const generateTimeRange = () => {
  const options: Option[] = [];
  for (let m = 0; m < 1440; m += 15) {
    const time = `${Math.floor(m / 60)
      .toString()
      .padStart(2, '0')}:${(m % 60).toString().padStart(2, '0')}`;
    options.push({
      label: time,
      value: time,
    });
  }
  return options;
};

const TimePicker = ({
  id,
  type,
  label,
  value,
  onChange,
  invalid,
  onClick,
  unmaskForClarity,
  ...props
}: TimePickerProps) => {
  const timeOptions = generateTimeRange();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange?.(event.target.value, type);
  };

  return (
    <Ui.Dropdown
      // Clarity unmask (LPOT-1716): select content is auto-masked in every
      // masking mode regardless of ancestor attributes; must sit on the field.
      data-clarity-unmask={unmaskForClarity ? 'true' : undefined}
      id={id}
      label={label}
      value={value}
      options={timeOptions}
      onChange={handleChange}
      invalid={invalid}
      onClick={onClick}
      {...props}
    />
  );
};

export { TimePicker };
